import { useWizard } from "react-use-wizard";
import sellSteps from "../sellSteps";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";

const KnowPriceStep_1 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.step_1);
  };

  const handleNextStep = () => {
    goToStep(sellSteps.knowPrice.step_2);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Нажимая 'Далее >' подтверждаю стоимость работы риелтора 2.5%"
      />
    </div>
  );
};

export default KnowPriceStep_1;
